var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 3000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E91309",
    d: "M2879.588,1500.008c0,720.155-617.652,1303.944-1379.586,1303.944 c-761.927,0-1379.59-583.789-1379.59-1303.944c0-720.154,617.663-1303.96,1379.59-1303.96 C2261.936,196.048,2879.588,779.854,2879.588,1500.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C310",
    d: "M1880.439,852.483c145.33,0,263.139,593.878,263.139,1326.484h210.568 c0-788.979-212.123-1428.538-473.707-1428.538c-148.834,0-281.611,192.218-368.455,492.781 c-86.802-300.563-219.619-492.781-368.449-492.781c-261.587,0-473.724,639.559-473.724,1428.538h210.583 c0-732.606,117.839-1326.484,263.14-1326.484c145.348,0,263.214,548.198,263.214,1224.49h210.508 C1617.268,1400.681,1735.1,852.483,1880.439,852.483"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcdLogo);
export default __webpack_public_path__ + "static/media/mcd_logo.f6aaf9fedd2c245015c276e060602624.svg";
export { ForwardRef as ReactComponent };